import { z } from 'zod'

// Optional sub-fields use .nullish() (not .optional()): ContentStack returns an
// explicit `null` for an empty optional field, which .optional() would reject.
export const RawCmsCtaSchema = z
  .object({
    text: z.string(),
    variant: z.enum(['primary', 'secondary']).nullish(),
    url: z.string().nullish(),
    trigger_promocode: z.boolean().nullish(),
    // B20-1020 - Part 2
    // Legacy fields — removed in the CTA cleanup task once content is migrated
    // to url + trigger_promocode.
    intent: z.enum(['link', 'start_onboarding_wizard', 'start_onboarding_menu']).nullish(),
    href: z.string().nullish(),
  })
  .passthrough()
